import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { MonthPicker } from 'src/client/components/MonthPicker/MonthPicker';
import { MOBILE_LANDSCAPE } from 'src/client/constants/mediaQueries';
import { useSelector } from 'src/client/redux';
import styled from 'styled-components/macro';
import { routes } from 'src/client/utils/router';
import { PrevNextLink } from '../useYearLinks';

type RouteParams = {
  month?: string;
  year?: string;
};

const archivePath = routes.updates.routes.archive.path;

export const ArchiveHeader = () => {
  const birthdate = useSelector((state) => state.app.config.birthdate);
  const match = useRouteMatch<RouteParams>(routes.updates.routes.archiveDate.path);
  const history = useHistory();

  const goToDate = (year: string, month: string) => {
    const monthString = month.padStart(2, '0');
    const url = `${archivePath}/${year}/${monthString}`;
    history.push(url);
  };

  const today = moment().toObject();
  const month = match?.params.month || String(today.months + 1).padStart(2, '0');
  const year = match?.params.year || today.years;

  const archiveDate = moment(`${year}-${month}`, 'YYYY-MM');

  const nextMonth = archiveDate.clone().add(1, 'months');
  const hideNext = nextMonth.isAfter(moment());
  // Link to /updates/archive if the next month is now
  const nextRoute = nextMonth.isSame(moment(), 'month') ? archivePath : nextMonth.format(`[${archivePath}/]YYYY/MM`);

  const prevMonth = archiveDate.clone().subtract(1, 'months');
  const hidePrev = prevMonth.isBefore(birthdate * 1000);
  const prevRoute = prevMonth.format(`[${archivePath}/]YYYY/MM`);

  return (
    <ArchiveWrapper>
      <PrevNextLink $disabled={hidePrev} to={prevRoute}>
        <FontAwesomeIcon size="sm" icon={faChevronLeft} aria-hidden="true" />
      </PrevNextLink>

      <MonthPicker
        title={`${archiveDate.format('MMMM YYYY')} Updates`}
        onSelect={goToDate}
        selectedDate={archiveDate.format('YYYY-MM')}
        minTimestamp={birthdate}
      />

      <PrevNextLink $disabled={hideNext} to={nextRoute}>
        <FontAwesomeIcon size="sm" icon={faChevronRight} aria-hidden="true" />
      </PrevNextLink>
    </ArchiveWrapper>
  );
};

const ArchiveWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${MOBILE_LANDSCAPE} {
    justify-content: flex-start;
    gap: 10px;
  }
`;
